<template>
  <div class="sas-results-content pa-4">

    <SmartAgencySearchResult
      v-if="searchState.scope === '' || searchState.scope === 'agency'"
      :agencies="agencies"
      @select-agency="$emit('select-agency', $event)" />

    <div v-if="(searchState.scope === '' || searchState.scope === 'agent')" class="sas-results-section">
        <v-data-table
          v-if="agents.length > 0"
          :headers="agentHeaders"
          :items="agents"
          hide-default-footer
          disable-pagination
          dense
          class="sas-table sas-table-agent"
          no-data-text="Aucun agent trouvé."
          @click:row="onAgentRowClick"
      >
        <template #header.actions>
          <v-chip small :style="agentsChipStyle()">Agents</v-chip>
        </template>
        <template #item.actions="{ item }">
          <v-btn icon x-small class="sas-plus-btn" @click.stop="$emit('select-agent', item)">
            <v-icon small>mdi-plus</v-icon>
          </v-btn>
        </template>

        <template #item.agencyName="{ item }">
          <span :class="{ 'sas-row-inactive': !item.active }">
            {{ item.agencyName}}
          </span>
        </template>

        <template #item.firstname="{ item }">
          <span :class="{ 'sas-row-inactive': !item.active }">
            {{ item.firstname}}
          </span>
        </template>

        <template #item.lastname="{ item }">
          <span :class="{ 'sas-row-inactive': !item.active }">
            {{ item.lastname}}
          </span>
        </template>

        <template #item.email="{ item }">
          <span class="caption" :class="{ 'sas-row-inactive': !item.active }">
            {{ item.email}}
          </span>
        </template>

        <template #item.active="{ item }">
          <span>
            <AgentActiveChip x-small use-boolean :value="item.active"/>
          </span>
        </template>
      </v-data-table>

      <div v-else class="d-flex align-center pl-4">
        <v-chip small :style="agentsChipStyle()">Agents</v-chip>
        <div class="mx-4" @click="$emit('open-quick-form')">
          <v-chip small class="cursor-pointer">
            <v-icon small color="grey darken-1">mdi-plus</v-icon>
            <span class="font-weight-medium grey--text text--darken-2">Création rapide</span>
          </v-chip>
        </div>
        <p class="caption grey--text">Aucun agent trouvé.</p>
      </div>


      <div v-if="agents.length > 0" @click="$emit('open-quick-form')">
        <v-chip small class="cursor-pointer ml-8">
          <v-icon small color="grey darken-1">mdi-plus</v-icon>
          <span class="font-weight-medium grey--text text--darken-2">Création rapide</span>
        </v-chip>
      </div>
    </div>
  </div>
</template>

<script>
import FormMixin from "@/components/mixins/FormMixin";
import SmartAgencySearchResult from "@/views/hlagons/workshop/SmartAgencySearchResult.vue";
import AgentActiveChip from "@/components/commons/AgentActiveChip.vue";

export default {
  name: "SmartAgentSearchResults",
  components: {AgentActiveChip, SmartAgencySearchResult},
  mixins: [FormMixin],
  props: {
    searchState: {
      type: Object,
      required: true,
    },
    agencies: {
      type: Array,
      default: () => [],
    },
    agents: {
      type: Array,
      default: () => [],
    },
  },
  emits: ["select-agency", "select-agent", "open-quick-form"],
  watch: {},
  computed: {
    agentHeaders() {
      return [
        { text: "", value: "actions", sortable: false, width: 60, align: "center" },
        { text: "Prénom", value: "firstname" },
        { text: "Nom", value: "lastname" },
        { text: "Agence", value: "agencyName" },
        { text: "Email", value: "email" },
        { text: "Actif", value: "active" },
      ]
    },
  },
  methods : {
    agentsChipStyle() {
      return {
        backgroundColor: "#FFE0B2", // orange-lighten-4
        color: "#EF6C00", // orange-darken-3
      }
    },
    onAgentRowClick(item) {
      this.$emit('select-agent', item)
    },
  }
};
</script>

<style scoped>
.cursor-pointer {
  cursor: pointer;
}

.sas-results-section {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.sas-results-content {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.sas-table {
  font-size: 12px;
  cursor: pointer;
}

.sas-row-inactive {
  opacity: 0.5;
}

.sas-table ::v-deep tbody tr:hover {
  background-color: transparent !important;
  cursor: pointer;
}

.sas-table-agent ::v-deep tbody tr:hover td {
  color: #F57C00 !important;
}
.sas-table-agent ::v-deep tbody tr:hover .sas-plus-btn {
  border-color: #F57C00 !important;
  background-color: #FFE0B2;
}

.sas-plus-btn {
  width: 24px;
  height: 24px;
  min-width: 24px !important;
  border-radius: 999px;
  border: 1px solid #dadce0;
}

</style>